import { useTranslation } from "react-i18next";

export default function SpeakerSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-cream">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("seminars.speaker.label")}</span>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl overflow-hidden border border-warm-gray/60">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left - Name & Title */}
              <div className="lg:col-span-2 bg-graphite p-8 md:p-10 flex flex-col justify-center">
                <span className="inline-block w-14 h-14 rounded-full bg-champagne/20 flex items-center justify-center mb-6">
                  <i className="ri-user-star-line text-2xl text-champagne" />
                </span>
                <h3 className="text-white text-[1.625rem] md:text-[1.875rem] mb-2">
                  {t("seminars.speaker.name")}
                </h3>
                <p className="text-champagne text-base font-sans font-medium mb-0">
                  {t("seminars.speaker.title")}
                </p>
              </div>

              {/* Right - Bio & Credentials */}
              <div className="lg:col-span-3 p-8 md:p-10">
                <p className="text-medium-gray text-base leading-relaxed mb-8">
                  {t("seminars.speaker.desc")}
                </p>

                <div className="space-y-4">
                  {["seminars.speaker.point1", "seminars.speaker.point2", "seminars.speaker.point3"].map((key) => (
                    <div key={key} className="flex items-start gap-3">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-champagne/10 shrink-0 mt-0.5">
                        <i className="ri-medal-line text-base text-champagne" />
                      </span>
                      <p className="text-graphite text-[1.0625rem] font-sans font-medium mb-0 leading-relaxed">
                        {t(key)}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}